"use strict"

import { get } from "svelte/store";
import { adminId } from "../store";
import { getUserIP } from "./utilities";

let cookies = false;

let current = []

const cookieName = "chatwith_storage"

let protoType = {
  "calls": []
}


export const setCookies = (value) => {
  cookies = value
  if (value === false) {
    const items = { ...localStorage };
  }
}


export const setLocalStorage = (key, value, block = 'calls') => {
  if (cookies === true) {
    saveItemToStorage(key, value, getAll());
  }
}


export const getLocalStorage = (key, block = 'calls') => {

  if (cookies === false) {
    return false
  }

  const data = key ? getItemFromStorage(key, getAll()) : "";
  if (data && data.hasOwnProperty("payload") === true) {
    return data.payload
  }
  return null

}


const getAll = () => {
  const data = localStorage.getItem(cookieName);
  if (data === null) {
    return protoType
  }
  else {
    return JSON.parse(data)
  }
}

const getItemFromStorage = (id, storageObject, block = 'calls') => {
  const data = storageObject[block].find((item) => id == item.id)
  return data;

}

const saveItemToStorage = (id, payload, storageObject, block = 'calls') => {
  const existingItem = getItemFromStorage(id, storageObject, 'calls')
  if (existingItem) {
    const index = storageObject[block].findIndex((obj) => obj.id == id)
    if (index > -1) {
      storageObject[block].splice(index, 1);
    }
  }
  storageObject[block].push({ id: id, payload: payload })
  localStorage.setItem(cookieName, JSON.stringify(storageObject))
}

export const updateVals = (savedForm, newForm, ischatform) => {

  if (ischatform === true) {
    return newForm
  }

  if (!savedForm) {
    return newForm
  }
  //return newForm

  newForm.items.forEach((i, index) => {
    const data = savedForm.items.find(savedItem => savedItem.label == i.label)
    if (data) {
      newForm.items[index].val = data.val
    }
  })
  return newForm

}

export const usedToChat = () => {
  if (cookies) {
    localStorage.setItem('tochatuser', "true")
  }
}

export const isReturnUser = () => {
  if (cookies) {
    if (localStorage.getItem('tochatuser')) {
      return true
    }
    else if (localStorage.getItem(cookieName)) {
      return true
    }
  }
  return false
}

export const saveFormToLocalStorage = (formId, formData) => {
  localStorage.setItem(formId, JSON.stringify(formData))
}

export const getFormFromLocalStorage = (formId) => {
  return JSON.parse(localStorage.getItem(formId))
}

export const saveLeadFingerprint = async () => {
  try {
    const adminIdStore = get(adminId);
    if (!adminIdStore) {
      console.warn('Admin ID no disponible, no se guarda lead.');
      return;
    }

    const ip = await getUserIP();
    const leads = JSON.parse(localStorage.getItem('tochatbe_last_connections') || '{}');

    leads[adminIdStore] = { ip, timestamp: Date.now() };

    localStorage.setItem('tochatbe_last_connections', JSON.stringify(leads));
  } catch (err) {
    console.error('Error saving lead fingerprint:', err);
  }
};

export const hasLeadForAdmin = () => {
  const adminIdStore = get(adminId);
  if (!adminIdStore) {
    console.warn('Admin ID no disponible, no se puede verificar lead.');
    return false;
  }
  const leads = JSON.parse(localStorage.getItem('tochatbe_last_connections') || '{}');
  return !!leads[adminIdStore];
};

export const getSavedIpForAdmin = () => {
  const adminIdStore = get(adminId);
  const leads = JSON.parse(localStorage.getItem('tochatbe_last_connections') || '{}');
  return leads[adminIdStore]?.ip || null;
};

const VISITOR_KEY_PREFIX = 'cw_visitor_';

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export const getOrCreateVisitorId = (widgetId) => {
  const key = VISITOR_KEY_PREFIX + widgetId;
  let visitorId = localStorage.getItem(key);
  if (!visitorId) {
    visitorId = generateUUID();
    localStorage.setItem(key, visitorId);
  }
  return visitorId;
};


